var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"page-title"},[_c('span',[_vm._v("Open Account")])]),_c('div',{staticClass:"md-layout",staticStyle:{"margin-top":"15px"}},[_c('div',{staticClass:"md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100"})])])}]
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c98e73f2","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Page/OpenAccount.vue
// module id = null
// module chunks = 